const SELECTOR = '.link.select_account';

$(document).on('click', SELECTOR, (e) => {
  const $target = $(e.target);
  const $accountSelect = $target.parent().find('.selector-account');
  $target.addClass('is-hidden');
  $accountSelect.removeClass('is-hidden');
});
